import { render, staticRenderFns } from "./DisclaimerForbidden.vue?vue&type=template&id=1d76d692&scoped=true&"
import script from "./DisclaimerForbidden.vue?vue&type=script&lang=js&"
export * from "./DisclaimerForbidden.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerForbidden.vue?vue&type=style&index=0&id=1d76d692&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76d692",
  null
  
)

export default component.exports